export { default as Add} from "./icons/add.svg";
export { default as ArrowBack} from "./icons/arrowBack";
export { default as Arrowdown} from "./icons/arrowdown";
export { default as Download} from "./icons/download.svg";
export { default as Arrowleft} from "./icons/arrowleft";
export { default as BillCheck} from "./icons/billCheck.svg";
export { default as BillCheck2} from "./icons/billCheck";
export { default as Calendar} from "./icons/calendar.svg";
export { default as Calendar2} from "./icons/calendar2.svg";
export { default as Cancel} from "./icons/cancel";
export { default as CardTransfer} from "./icons/cardTransfer";
export { default as CheckRead} from "./icons/checkRead.svg";
export { default as Danger} from "./icons/danger.svg";
export { default as DangerTriangle} from "./icons/dangerTriangle.svg";
export { default as SavedUp} from "./icons/savedUp";
export { default as Documentupload} from "./icons/documentUpload.svg";
export { default as Edit} from "./icons/edit.svg";
export { default as FilterIcon} from "./icons/filter";
export { default as TransactionIcon} from "./icons/transaction";
export { default as Folder} from "./icons/folder";
export { default as OfferInsurance} from "./icons/offerInsurance";
export { default as Forward} from "./icons/forward";
export { default as Hamburgermenu} from "./icons/hamburgerMenu.svg";
export { default as LetterUnread} from "./icons/letterUnread";
export { default as Logout} from "./icons/logout.svg";
export { default as Logout2} from "./icons/logout2";
export { default as MenuIcon} from "./icons/menu.svg";
export { default as Messagequestion} from "./icons/messagequestion";
export { default as Notification} from "./icons/notification.svg";
export { default as PersonalCard} from "./icons/personalcard";
export { default as SearchNormal} from "./icons/searchnormal.svg";
export { default as ServerSquareUpdate} from "./icons/serverSquareUpdate.svg";
export { default as Size} from "./icons/size.svg";
export { default as SmartPhone} from "./icons/smartPhone";
export { default as User} from "./icons/user.svg";
export { default as UsersGroup} from "./icons/usersGroup";
export { default as VerifiedCheck} from "./icons/verifiedCheck.svg";
export { default as Wiki} from "./icons/wiki";
export { default as ArrowLeft2} from "./icons/arrowLeft2.svg";
export { default as SquareTransferVertical} from "./icons/squareTransferVertical";
export { default as Money} from "./icons/money";
export { default as Star} from "./icons/star.svg";
export { default as DangerSquare} from "./icons/dangerSquare.svg";
export { default as CircleTick} from "./icons/circleTick.svg";
export { default as Reply} from "./icons/reply";
export { default as Inquery1} from "./icons/inquery1.png";
export { default as Inquery2} from "./icons/inquery2.png";
export { default as Inquery3} from "./icons/inquery3.png";
export { default as Inquery4} from "./icons/inquery4.png";
export { default as Inquery5} from "./icons/inquery5.svg";
export { default as Calendar3} from "./icons/calender3.svg";
export { default as History} from "./icons/history.svg";
export { default as ChatSquare} from "./icons/chatSquare.svg";
export { default as GraphNewUp} from "./icons/Graph New Up.svg";
export { default as ReplyPic} from "./icons/reply.svg";
export { default as Tick} from "./icons/tick.svg";
export { default as More} from "./icons/more.svg";
export { default as CardHolder} from "./icons/cardholder.svg";
export { default as Chart} from "./images/chart.svg";
export { default as FolderCheck} from "./icons/folderCheck.svg";
export { default as FolderClose} from "./icons/folderClose.svg";
export { default as Letter} from "./icons/letter";
export { default as Plus} from "./icons/plus.svg";
export { default as CheckboxCheck} from "./icons/checkboxCheck.svg";
export { default as CallCalling} from "./icons/call-calling.svg";
export { default as FolderCheck2} from "./icons/folderCheck2.svg";
export { default as SelectMultiple} from "./icons/selectMultiple.svg";
export { default as vector} from "./icons/vector.svg";
export { default as vector2} from "./icons/vector2.svg";
export { default as vector3} from "./icons/vector3.svg";
export { default as vector4} from "./icons/vector4.svg";
export { default as vector5} from "./icons/vector5.svg";
export { default as vector6} from "./icons/vector6.svg";
export { default as MoneySend} from "./icons/moneySend.svg";
export { default as Dashboard} from "./icons/dashboard";
export { default as Peyment} from "./icons/peyment";

export { default as Calendar4} from "./icons/calendar4.svg";
export { default as CardPos} from "./icons/cardPos.svg";
export { default as CardReceive} from "./icons/cardReceive.svg";
export { default as MoneyTime} from "./icons/moneyTime.svg";
export { default as TrendUp} from "./icons/trendUp.svg";
export { default as WalletAdd} from "./icons/walletAdd.svg";



export { default as DashboardFooter} from "./icons/dashboardFooter";
export { default as PolicyFooter} from "./icons/policyFooter";
export { default as ProfileFooter} from "./icons/profileFooter";
export { default as NotificationFooter} from "./icons/notificationFooter";
export { default as MenuFooter} from "./icons/menuFooter";


export { default as Policy} from "./icons/policy.svg";
export { default as Wallet} from "./icons/wallet";
export { default as BarChart} from "./icons/barChart.svg";
export { default as WalletMoney} from "./icons/walletMoney.svg";

export { default as AlertIcon} from "./icons/alertIcon.svg";
export { default as Import} from "./icons/import.svg";

export { default as Arrowdown2} from "./icons/arrowdown2.svg";
export { default as Maskan2} from "./images/maskan2.svg";









export { default as NotFoundPic} from "./images/404.png";
export { default as Logo} from "./images/logo.png";
export { default as MiniLogo} from "./images/miniLogo.png";


export { default as ProfilePic} from "./images/p0.png";
export { default as Prerenderbg} from "./images/prerenderbg.png";
export { default as Prerenderbg2} from "./images/prerenderbg2.png";
export { default as Rocket} from "./images/rocket.png";
export { default as VerticalLogo} from "./images/verticallogo.svg";
export { default as ServerPic} from "./images/500.png";
export { default as EmptiList} from "./images/emptiList.png";
export { default as EmptyMessaging} from "./images/emptyMessaging.svg";
export { default as IssuingImage} from "./images/issuing.svg";
export { default as StatusUp} from "./icons/statusUp";



export { default as LogoBg} from "./images/logoBg.png";




